import React from 'react';

import { Spinner } from 'components/ui/spinner';

export const ThemeLoader: React.FC = () => (
  <Spinner className="absolute top-1/2 left-1/2 size-16" />
);
